import styled from '@emotion/styled'
import {
  TextField,
  Checkbox,
  textFieldClasses,
  Autocomplete,
  autocompleteClasses,
  MenuItem,
  menuItemClasses,
  outlinedInputClasses,
  chipClasses,
  Box
} from '@mui/material'

export const StyledAutoComplete = styled(Autocomplete)(({theme}) => ({
  [`& .${outlinedInputClasses.root}`]: {
    backgroundColor: theme.palette.common.black2,
    color: theme.palette.common.white,
    padding: '0px 8px',
    fontSize: '14px',
    minHeight: '40px',
    '& fieldset': {
      border: 'none'
    }
  },
  [`& .${autocompleteClasses.tag}`]: {
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.green,
    fontSize: '12px'
  },
  [`& .${chipClasses.root}`]: {
    padding: '0px',
    height: '26px'
  },
  [`& .${chipClasses.deleteIcon}`]: {
    color: `${theme.palette.common.black2} !important`,
    opacity: '0.7'
  },
  [`& .${autocompleteClasses.clearIndicator}`]: {
    color: theme.palette.common.white
  },
  [`& .${autocompleteClasses.popupIndicator}`]: {
    color: theme.palette.common.white
  }
}))

export const StyledMenuItem = styled(MenuItem, {shouldForwardProp: (prop) => prop !== 'isMultiSelect'})(
  ({isMultiSelect, theme}) => ({
    [`&.${menuItemClasses.root}`]: {
      fontSize: '14px',
      padding: isMultiSelect ? '0px' : '2px 16px',
      whiteSpace: 'pre-wrap'
    },
    '&.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: `${theme.palette.common.lightTeal} !important`
    }
  })
)

export const StyledTextField = styled(TextField)(({theme}) => ({
  [`& .${textFieldClasses.root}`]: {
    backgroundColor: theme.palette.common.black2
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.common.white,
    opacity: 0.8
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.common.grey6
  }
}))

export const StyledCheckBox = styled(Checkbox)(({theme}) => ({
  color: theme.palette.common.white,
  '&.Mui-checked': {
    color: theme.palette.common.teal3
  }
}))

export const StyledNoOptionsTextBox = styled(Box)(({theme}) => ({
  color: theme.palette.common.white,
  fontSize: '14px'
}))

export const StyledLoaderBox = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  color: theme.palette.common.green,
  fontSize: '12px'
}))
